import { Component, OnInit, AfterViewInit } from '@angular/core';
import { BaseComponent } from '@library-shared/base/base.component';
import { spUser_List } from '@models/StoredProcs/spUser_List';

import { GlobalService } from '@services/global.service';
import { Router, RouterModule } from '@angular/router';
import { EventBusService } from '@library-shared/services/event-bus/event-bus.service';
import { EventBusEventType } from '@library/event-bus-event-type';
import { UserService } from '@services/user/user.service';
import { NgxUiLoaderModule, NgxUiLoaderService } from 'ngx-ui-loader';
import { DxButtonModule, DxDataGridModule, DxToolbarModule, DxTooltipModule } from 'devextreme-angular';
import { DxiColumnModule, DxiItemModule, DxiTotalItemModule, DxoFilterRowModule, DxoPagerModule, DxoPagingModule, DxoSummaryModule } from 'devextreme-angular/ui/nested';

@Component({
    selector: 'app-user-manager',
    templateUrl: './user-manager.component.html',
    styleUrls: ['./user-manager.component.scss'],
    imports: [DxTooltipModule, DxiTotalItemModule, DxoSummaryModule, DxiColumnModule, DxoPagerModule, DxoPagingModule, DxoFilterRowModule, DxDataGridModule, DxButtonModule,
        DxiItemModule, DxToolbarModule, NgxUiLoaderModule, DxDataGridModule, DxoFilterRowModule, DxoPagerModule, DxoPagingModule, DxiTotalItemModule, RouterModule]
})
export class UserManagerComponent extends BaseComponent implements OnInit, AfterViewInit {
    dataSource: spUser_List[] = [];
    sSearch = '';

    constructor(
        private userService: UserService,
        private globalService: GlobalService,
        private router: Router,
        private eventBusService: EventBusService,
        private loaderService: NgxUiLoaderService
    ) {
        super();
    }

    ngOnInit() {
        this.globalService.AuthenticatedUser().subscribe((user) => {
            if (!user?.isAdmin) {
                this.router.navigateByUrl(`/home`);
            }
        });
    }

    ngAfterViewInit(): void {
        this.loadData();
    }

    onRefresh() {
        this.loadData();
    }

    onSearch() {
        this.loadData();
    }

    loadData() {
        this.isLoading = true;
        this.loaderService.startLoader(this.componentID);
        this.userService.User_List().subscribe((data) => {
            this.dataSource = data.records;
            this.isLoading = false;
            this.loaderService.stopLoader(this.componentID);
        });
    }

    onAdd() {
        this.router.navigateByUrl(`/user/edit/${GlobalService.zeroGuid}`);
    }

    closeView() {
        const url = this.router.url;
        this.log.data(url);
        this.eventBusService.emitChange(EventBusEventType.CloseTab, {
            url,
        });
        this.router.navigate(['home']);
    }
}
